import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { WORKSPACES_VIEWS, WORKSPACE_TYPES, WorkspaceType } from '@/features/workspaces/constants';

export const createWorkspaceOpenAtom = atom(false);

export const workspacesViewAtom = atomWithStorage<(typeof WORKSPACES_VIEWS)[number]>(
  'evaluations_view',
  'board',
);

export const visibleWorkspaceTypesAtom = atomWithStorage<WorkspaceType[]>(
  'evaluations_visible_types',
  [...WORKSPACE_TYPES],
);

export const recentWorkspacesAtom = atomWithStorage<
  Record<string, { id: string; name: string; type: WorkspaceType; projectId: string }[]>
>('recent-workspaces', {}, undefined, { getOnInit: true });

export const versionPanelOpenAtom = atom(false);
export const versionPanelWidthAtom = atom(320);
